export default "__VITE_ASSET__dbNEFxgT__"